
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Calendar, Download } from 'lucide-react';

export const ReportsTab = () => {
  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-center">
          <CardTitle className="flex items-center gap-2">
            <Calendar className="h-5 w-5 text-green-500" />
            Compliance Reports
          </CardTitle>
          <Button variant="outline" size="sm" className="flex items-center gap-2">
            <Download className="h-4 w-4" />
            Export
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Card>
            <CardHeader>
              <CardTitle className="text-sm">Trade Surveillance</CardTitle>
            </CardHeader>
            <CardContent>
              <Button className="w-full" variant="outline">Generate Report</Button>
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle className="text-sm">Communications Review</CardTitle>
            </CardHeader>
            <CardContent>
              <Button className="w-full" variant="outline">Generate Report</Button>
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle className="text-sm">Risk Assessment</CardTitle>
            </CardHeader>
            <CardContent>
              <Button className="w-full" variant="outline">Generate Report</Button>
            </CardContent>
          </Card>
        </div>
      </CardContent>
    </Card>
  );
};
